function ScreeningServicePlanList({ children }) {
  
    return (    
        <div className="flex gap-x-4 pt-8 justify-center">
            {children}
        </div>  
    )
}

export default ScreeningServicePlanList;